import React from 'react'
import { MultiSelect } from 'react-selectize'
import Tag from './tag'
import { hydrateTagComboOptions, tagsToOptions } from '../common/components/tag_select'
import { genColor } from '../util/tag_utils'
import { prepSigilMeta } from '../common/components/team_sigil'

class TagSelect extends React.Component {
    constructor(props) {
        super(props)
        this.renderTagOrTagCombo = this.renderTagOrTagCombo.bind(this)
        this.handleValuesChange  = this.handleValuesChange.bind(this)
        this.createFromSearch = this.createFromSearch.bind(this)
        this.optionRemover    = this.optionRemover.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleAnchorChange = this.handleAnchorChange.bind(this)

        const valsLength = props.values.length
        const initialAnchor = valsLength > 0 ? props.values[valsLength - 1] : null

        this.state = {
            anchor: initialAnchor,
            search: '',
        }
    }

    componentDidMount() {
        if (this.props.anchor) {
            this.handleAnchorChange(this.props.anchor)
        }
    }

    createFromSearch(options, values, search) {
        const { selectedTeamId, teams=[], viewerIsTeamAdmin, viewerPersonalTeamId } = this.props
        const tSearch = search.trim()
        // prevent blanks
        if (!tSearch) return null

        // prevent dupes
        const optionLabels = options.map(op => op.label) // Could refactor to only iterate over the list once
        if (optionLabels.includes(tSearch)) return null

        // prevent dupes
        const valueLabels  = values.map(val => val.label) // Could refactor to only iterate over the list once
        if (valueLabels.includes(tSearch)) return null

        const teamId = viewerIsTeamAdmin ? selectedTeamId : viewerPersonalTeamId

        return {
            name: tSearch,
            color: genColor(tSearch),
            teamId: teamId,
            teamSigil: viewerIsTeamAdmin ? prepSigilMeta(teams[teamId]) : undefined,
        }
    }

    optionRemover(item) {
        return () => {
            const filteredValues = this.props.values.filter(tag => tag.label !== item.label)
            return this.props.onValuesChange(filteredValues)
        }
    }

    handleValuesChange(values) {
        // flatten tags and tag combos into an array of tags
        // when adding a combo, replace any previous values
        const flattened = values.reduce((acc, c) =>  {

            // Is it a combo and does the combo have more than one tag?
            return c.combo && c.tags.length > 1
                // Spread the tags of the combo, this will erase existing tags
                ? [...c.tags]
                // Is it a combo and are the tags less than or equal to one?
                : c.combo && c.tags.length <= 1
                    // If yes, Keep the current tags and spread the tags of the combo
                    ? [...acc, ...c.tags]
                    // If no, it is not a combo so add the tag to the array of tags
                    : [...acc, c]}
            , [])

        // dedupe any duplicate tags
        const deduped = flattened.filter((tag, i, arr) => {
            // compare ids unless new tag, tag.id returns undefined
            // for new tags therefore item.name is used
            return arr.findIndex(item => item.id ? item.id === tag.id : item.name === tag.name) === i
        })

        // set the cursor anchor to the last, and fire change handler and reset the search text
        this.setState({
            anchor: deduped[deduped.length - 1],
            search: '',
        })
        return this.props.onValuesChange(deduped)
    }

    handleSearchChange(searchText) {
        this.setState({
            search: searchText,
        })
    }

    handleAnchorChange(anchorItem) {
        this.setState({
            anchor: anchorItem,
        })
    }

    filterOptions(options, values, search) {
        const unselectedOptions = options.filter(option => {
            if (!option.combo) {
                // if the option is not a combo just filter out by id
                return values.findIndex(value => value.id === option.id) === -1
            }
            // if tag combo, filter out combos if all child tags are already selected
            return option.tags.some(tag => values.findIndex(value => value.id === tag.id) === -1)
        })

        if (search) {
            // if seaching, filter by search string
            return unselectedOptions.filter(option => option.label.toLowerCase().includes(search.toLowerCase()))
        }

        return unselectedOptions
    }

    renderTagCombo(combo) {
        return (
            <span className="tag-combo">
                {combo.tags.map((tag, i) => <Tag key={tag.id + i} {...tag} />)}
            </span>
        )
    }

    renderTagOrTagCombo(item) {
        // if no id, just render text, "Add ____ ..."
        if (!item.combo && !item.id) {
            return `Add ${item.name} ...`
        }

        if (item.combo) {
            return this.renderTagCombo(item)
        }

        return <Tag {...item} />
    }

    renderTags = (tag, teams) => {
        return Tag(tag, teams || this.props.teams)
    }

    render() {
        const { tags=[], tagMap={}, recentTagCombos=[], teams={}, values=[], className="", placeholder="", allowCreate=true, autofocus=true, renderValue=this.renderTags } = this.props
        const createFromSearch = allowCreate ? this.createFromSearch : null

        const combosWithValues = hydrateTagComboOptions(recentTagCombos, tagMap, teams)


        const options = [ ...combosWithValues, ...tagsToOptions(tags, teams)] // note: tags have ids, new tags will not

        const uniqueOptions = options
            // calc unique key for each option
            .map(option => {
                const teamIds = option.combo ? option.tags.map(t => t.teamId).join("-") : option.teamId
                const uniqueKey = teamIds + "-" + option.label
                return { ...option, uniqueKey }
            })
            .filter((elem, index, options) => options.map((elem) => elem.uniqueKey).indexOf(elem.uniqueKey) === index )

        return (
            <MultiSelect
                createFromSearch={createFromSearch}
                renderValue={renderValue}
                renderOption={this.renderTagOrTagCombo}
                search={this.state.search}
                onSearchChange={this.handleSearchChange}
                onValuesChange={this.handleValuesChange}
                filterOptions={this.filterOptions}
                onAnchorChange={this.handleAnchorChange}
                placeholder={placeholder}
                anchor={this.state.anchor}
                options={uniqueOptions}
                className={className}
                values={values}
                closeOnSelect={true}
                autofocus={autofocus}
            />
        )
    }
}

export default TagSelect



// WEBPACK FOOTER //
// ./src/components/tag_select.jsx